import { Injectable, Type } from '@angular/core';
import { InformationTemplateComponent } from './information-template/information-template.component';
import { ResultTemplateComponent } from "./result-template/result-template.component";

import { BaseInformationTemplateComponent } from "../base-information-template.component";
import { BaseService } from "../base.service";
import { BaseResultTemplateComponent } from "../base-result-template.component";

@Injectable({providedIn: 'root'})
export class DokumentenFreigabeService extends BaseService {

  WORKFLOW_NAME = 'dokumenten-freigabe';
  static WORKFLOW_NAME = 'dokumenten-freigabe';

  getInformationTemplate(): Type<BaseInformationTemplateComponent> {
    return InformationTemplateComponent;
  }

  getResultTemplate(): Type<BaseResultTemplateComponent> {
    return ResultTemplateComponent;
  }
}
